
import Header from '../component/Header'
import Footer from '../component/Footer';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MarkunreadIcon from '@mui/icons-material/Markunread';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Link } from 'react-router-dom';
import address from '../assests/office_address.png'
export default function ContactUS() {
    return (
        <>
            <Header />
            <section className="relative overflow-hidden bg-gradient-to-br from-slate-950 via-blue-950 to-cyan-900  pt-36 pb-10 px-4 sm:px-6 lg:px-8">
                {/* Background Glow */}
                <div className="absolute top-0 left-0 w-72 h-72 bg-cyan-500/20 blur-[120px]" />
                <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-500/20 blur-[140px] rounded-full" />

                <div className="absolute inset-0 opacity-10 bg-[linear-gradient(rgba(255,255,255,.15)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.15)_1px,transparent_1px)] bg-[size:40px_40px]" />

                <div className="max-w-7xl mx-auto relative z-10">
                    <div className="flex items-center  flex-wrap gap-2 text-sm text-white/70 mb-6">Home
                        <KeyboardArrowRightIcon className="w-4 h-4" />
                        <span className="text-cyan-300">
                            Contact Us
                        </span>
                    </div>

                    <div className='max-w-6xl'>
                        <h1 className="text-3xl sm:text-3xl lg:text-4xl font-bold text-white leading-tight mb-5">
                            Start a Conversation

                        </h1>
                        <p className=" text-white/70 text-sm sm:text-base lg:text-lg leading-relaxed mb-8">
                            each out to discuss funding opportunities, financial strategies, and customized business financing solutions.
                        </p>
                    </div>
                </div>
            </section>
            <section className="w-full py-20 px-4 sm:px-6 lg:px-8">
                <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-8">

                    {/* LEFT: FORM */}
                    <div className="lg:col-span-2 p-6 sm:p-8 ">

                        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
                            Get in Touch
                        </h2>
                        <p className="text-gray-600 mb-6">
                            Have questions about our financial solutions? Our advisors are ready to assist you.
                        </p>

                        <form className="grid grid-cols-1 sm:grid-cols-2 gap-4">

                            <input
                                type="text"
                                placeholder="Full Name"
                                className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-orange-400"
                            />

                            <input
                                type="email"
                                placeholder="Email Address"
                                className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-orange-400"
                            />

                            <input
                                type="text"
                                placeholder="Phone Number"
                                className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-orange-400"
                            />

                            <input
                                type="text"
                                placeholder="Company Name"
                                className="border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-orange-400"
                            />

                            <textarea
                                placeholder="How can we help you achieve your goals?"
                                rows={4}
                                className="sm:col-span-2 border rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-orange-400"
                            ></textarea>

                            <button
                                type="submit"
                                className="sm:col-span-2 bg-dark-gold hover:bg-orange-600 text-white py-3 rounded-lg font-medium transition"
                            >
                                Send Inquiry
                            </button>

                        </form>

                        <div className='grid grid-cols-2 gap-10 mt-16'>
                            {/* Call Us */}
                            <div className="bg-white p-5 rounded-xl shadow flex gap-4 items-start">
                                <div className="bg-premium-gold p-3 rounded-lg">
                                    <LocalPhoneIcon className="w-5 h-5 text-white" />
                                </div>
                                <div>
                                    <h3 className="font-semibold  text-lg">Call Us</h3>

                                    <p className="text-gray-400 text-xs">
                                        Mon–Sat: 10:00 AM – 6:00 PM
                                    </p>
                                    <p className="text-gray-600 text-xl font-semibold ms-text-primary pt-1">+91 99872 00488</p>
                                </div>
                            </div>

                            {/* Email */}
                            <div className="bg-white p-5 rounded-xl shadow flex gap-4 items-start">
                                <div className="bg-premium-gold p-3 rounded-lg">
                                    <MarkunreadIcon className=" w-5 h-5 text-white" />
                                </div>
                                <div>
                                    <h3 className="font-semibold text-gray-900">Email Us</h3>
                                    <p className="text-gray-600 text-sm">
                                        For detailed queries and documentation.
                                    </p>
                                    <p className="text-gray-600 text-xl font-semibold ms-text-primary pt-1">
                                        info@ybindia.in
                                    </p>
                                </div>
                            </div>
                        </div>


                    </div>

                    {/* RIGHT: CONTACT CARDS */}
                    <div className="flex flex-col">

                        <img src={address} alt="Corporate Address" style={{ borderRadius: '10px 10px 0 0' }} />
                        <div className="bg-[#072c4c] text-white p-6 shadow" style={{borderRadius:'0 0 10px 10px'}}>
                            <h3 className="font-semibold mb-2">Corporate Office</h3>
                            <p className="text-sm text-gray-300 mb-3 leading-7">
                                15th floor Best Sky Tower Netaji Subhash Place Pitampura Delhi 110034
                            </p>
                            <button className="text-[#0fce84] font-medium hover:underline">
                                Directions →
                            </button>
                        </div>





                       
                    </div>
                </div>

               
            </section>
            <Footer />
        </>
    )
}